import { PillsCategoriesCarousel } from '@client/components/PillsCategoriesCarousel/PillsCategoriesCarousel';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import cx from 'classnames';
import React, { useContext } from 'react';
import AnalyticsConstants from '../../../../../../constants/analytics';
import { CategoryRecommendationsContext } from '../CategoryRecommendationsProvider';
import Styles from '../McVrmLiteWidget.scss';
import { useCommonTrackingProperties } from '../utils';

export const CategoryPills = () => {
	const { categories, onSelectCategory, error, selectedCategoryCode } =
		useContext(CategoryRecommendationsContext);
	const { track } = useAnalyticsContext();
	const commonTrackingProperties = useCommonTrackingProperties();

	if (error === 'No recommended categories found' || categories.length === 0) {
		return null;
	}

	const handleCategoryClick = (categoryCode: string) => {
		track({
			event: AnalyticsConstants.WIDGET_CLICKED,
			properties: {
				...commonTrackingProperties,
				action: 'category',
				vendorCategory: categoryCode,
			},
		});
		onSelectCategory(categoryCode);
	};

	return (
		<PillsCategoriesCarousel
			categories={categories}
			selectedCategoryCode={selectedCategoryCode}
			onCategoryClick={handleCategoryClick}
			className={cx(Styles.pillsContainer, Styles.pillsNavButtonBackground)}
		/>
	);
};
